export const ContactMessages = {
  title: 'Contact',
  email: 'E-mail',
  firstName: 'Voornaam',
  lastName: 'Achternaam',
  phoneNumber: 'Telefoonnummer',
};
